import $auth from '@/utils/auth'

/* 管理员页面路由 */
import errorRouter from '../error'
import mainRouter from './main'
import signIssueRouter from './signIssue'
import settingRouter from './setting' //设置中心
import feeRouter from './fee' //账户中心
import orgRouter from './org'
import guideRouter from './guide'
import contract from './contract'
import companyRouter from './company'
import roleRouter from './role'
import logManage from './log'

export default {
  path: '/admin',
  component: () => import('@/layout/Empty.vue'),
  meta: { scrollToTop: true, layout: 'admin' },
  redirect: '/company/detail',
  beforeEnter: (to, from, next) => {
    /**
     * 不允许进入控制台的场景：
     * 1. 当前是用户身份
     * todo: 2. 如果企业员工，但未分配角色权限
     */
    if (!$auth.isSuperAdmin && !$auth.isMinAdmin) {
      next('/')
    }

    next()
  },
  children: [
    ...mainRouter,
    ...signIssueRouter,
    ...settingRouter,
    ...feeRouter,
    ...orgRouter,
    ...errorRouter,
    ...guideRouter,
    contract,
    ...companyRouter,
    ...roleRouter,
    ...logManage
  ]
}
